import script from "./BanOfficerForSiteView.vue?vue&type=script&setup=true&lang=js"
export * from "./BanOfficerForSiteView.vue?vue&type=script&setup=true&lang=js"

import "./BanOfficerForSiteView.vue?vue&type=style&index=0&id=f58b9a70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f58b9a70"]])

export default __exports__